import React from 'react'
import { Link,useLocation } from 'react-router-dom'
import { ReactComponent as HomeIcon} from '../../../images/icons/Dashboard.svg'
import { ReactComponent as SearchIcon} from '../../../images/icons/Search.svg'
import { ReactComponent as SellIcon} from '../../../images/icons/add.svg'
import { ReactComponent as NotificationIcon} from '../../../images/icons/NotificationFill.svg'
import { ReactComponent as ProfileIcon} from '../../../images/icons/User_Active.svg'

const Mobileicons = ({setMenuOpen}) => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    const currentRoute = useLocation().pathname.toLowerCase();
  return (
    <div className='mobile_icons_wrapper'>
      <div className='mobile_icons_container'>
        <Link to={'/'} onClick={()=>{setMenuOpen(false)}}>
            <div className={currentRoute === '/'? 'mobile_icon_item active' : 'mobile_icon_item'}>
                <HomeIcon width={'20px'} height={'20px'} />
            </div>
        </Link>
        <Link to={'/mobilesearch'} onClick={()=>{setMenuOpen(false)}}>
            <div className={currentRoute.includes('mobilesearch') ? 'mobile_icon_item active' : 'mobile_icon_item'}>
                <SearchIcon width={'20px'} height={'20px'} />
            </div>
        </Link>
        <Link to={'/dashboard/listings/add'} onClick={()=>{setMenuOpen(false)}}>
            <div className={currentRoute.includes('listings/add') ? 'mobile_icon_item active' : 'mobile_icon_item'}>
                <SellIcon width={'20px'} height={'20px'} />
            </div>
        </Link>
        <Link to={'/notifications'} onClick={()=>{setMenuOpen(false)}}>
            <div className={currentRoute.includes('notifications') ? 'mobile_icon_item active' : 'mobile_icon_item'}>
                <NotificationIcon width={'20px'} height={'20px'} />
            </div>
        </Link>
        {User !== null &&
            <Link to={'/user/'+User.username} onClick={()=>{setMenuOpen(false)}}>
                <div className={currentRoute.includes(User.username) ? 'mobile_icon_item active' : 'mobile_icon_item'}>
                    <ProfileIcon width={'20px'} height={'20px'} />
                </div>
            </Link>
        }
        {User === null &&
            <Link to={'/login'} onClick={()=>{setMenuOpen(false)}}>
                <div className={'mobile_icon_item'}>
                    <ProfileIcon width={'20px'} height={'20px'} />
                </div>
            </Link>
        }
      </div>
    </div>
  )
}

export default Mobileicons
